export default __webpack_public_path__ + "static/curve-54a3f756b2efd74f3671bab6af630499.svg";